// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3fFal","title":"AfterFrontImage_title__16dL9"};